import React from 'react';

import { getStatisticsFromOrigin } from "../helpers/requestHandler";
import { exportData, renderFullScreen } from '../helpers/utils';

import { Chart, Series, Export, ArgumentAxis, Label, Legend, Tooltip, ValueAxis } from 'devextreme-react/chart';
import { Card } from 'react-bootstrap';

class barChartUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          getData: [],
          errorMessage: ""
        };
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => {
        let resp = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetActiveUsersByInstanceRange")
        if(resp) {
            let respForm = resp.sort(function(a, b) { return a.count < b.count ? 1 : -1; })
            this.setState({ getData: respForm });
        }
    }

    render() {
        if(this.state.getData !== null) {
            return (
                <Card className="rounded-4">
                    <Card.Body>
                      <Card.Title>
                          Active Users ({global.config.dashboard.range} Days)
                          <div className='float-end'>
                            <span className="fullscreen-link" onClick={() => {renderFullScreen("#chartActiveUsers")}}>Full Screen</span>
                                <span> | </span>
                            <span className="fullscreen-link" onClick={() => {exportData("ActiveUsers", this.state.getData, global.config.dashboard.range)}}>Export</span>
                          </div>
                      </Card.Title>
                      <Card.Subtitle>
                        Number of Active User Logins by Instance based on selected range                      
                        </Card.Subtitle>
                      <Chart id="chartActiveUsers" dataSource={this.state.getData}>
                          <Legend visible={false} />
                          <Tooltip
                              enabled={true}
                              location="edge"
                              customizeTooltip={this.customizeTooltip}
                              zIndex={10000}
                          />
                          <ValueAxis type="logarithmic"/>
                          <Series
                          valueField="count"
                          argumentField="instance"
                          name="Active Users"
                          type="bar"
                          color="#d505f5" />
                          <Export enabled={true} />
                          <ArgumentAxis>
                            <Label
                                wordWrap="break"
                                overlappingBehavior={"rotate"}
                            />
                        </ArgumentAxis>
                      </Chart>
                    </Card.Body>
                </Card>
            
            );
        }
    }

    customizeTooltip(arg) {
        return {
            text: `${arg.argumentText} Sign-Ins: ${arg.valueText}`,
        }
    }
}

export default barChartUsers;
